import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Badge from 'Components/Atoms/Badge/Badge';

export default function ForecastValueStatusBadge(props) {
    const { isCompleted } = props;

    const { t } = useTranslation('forecasts');

    return (
        <Badge size="small" color={isCompleted ? 'success' : 'warning'} className="shrink-0">
            {t(isCompleted ? 'badge-completed' : 'badge-pending')}
        </Badge>
    );
}

ForecastValueStatusBadge.propTypes = {
    isCompleted: PropTypes.bool,
};
